// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"a78f0ecb","383":"10908a06","791":"e8fed861","941":"e5689e71"}[chunkId] + ".chunk.css";
};